<template>
  <a-dialog v-model="show" width="60vw" max-width="90vw" persistent scrollable>
    <v-card>
      <v-banner color="primaryLight1" sticky single-line tile>
        <v-toolbar color="primaryLight1">
          <v-toolbar-title>
            <v-tooltip bottom :disabled="!isEllipsis(meetingObject.meetingName)">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
              v-on="on"> {{ $t("agenda.lblCommentHeading", {title: ellipsis(meetingObject.meetingName)}) }} </span>
              </template>
              <span>{{ $t("agenda.lblCommentHeading", {title: meetingObject.meetingName}) }}</span>
            </v-tooltip>
          </v-toolbar-title>
          
          
          <v-spacer></v-spacer>
          <CloseIcon @click="close()" />
        </v-toolbar>
      </v-banner>
      <v-card-text
        style="color: black"
        v-if="getMeetingComments.length > 0 && viewMomCommentPermission"
      >
        <v-timeline :dense="$vuetify.breakpoint.smAndDown">
          <v-timeline-item
            v-for="comment in getMeetingComments"
            :key="`comment-timeline-${comment.id}`"
          >
            <span slot="opposite"
              ><span
                style="font-size: 18px !important"
                :class="`title font-weight-bold pageHeader--text`"
                >{{ commentDate(comment.createdDate) }}</span
              ></span
            >
            <mom-comment-timeline-card
              :comment="comment"
              @editComment="editComment"
            ></mom-comment-timeline-card>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-card-text
        class="text-h6"
        style="color: black; text-align: center"
        v-else
      >
        {{ $t("agenda.hRecordNotFound") }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="primaryDark"
          v-if="viewMomCommentPermission"
          text
          small
          @click="viewLog"
        >
          <v-icon left dark> mdi-history </v-icon>
          {{ $t("agenda.lblViewLog") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-tooltip bottom v-if="addMomCommentPermission">
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="mr-2"
              color="primaryDark"
              small
              v-bind="attrs"
              v-on="on"
              @click="createComment"
              v-if="addMomCommentPermission"
              ><span>{{ $t("agenda.lblAddComment") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("agenda.lblAddComment") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              color="secondary"
              small
              @click="close()"
              v-bind="attrs"
              v-on="on"
              ><span>{{ $t("btnClose") }}</span>
            </a-btn>
          </template>
          <span> {{ $t("btnClose") }} </span>
        </v-tooltip>
      </v-card-actions>
      <view-log-dialog
        v-if="viewLogDialog"
        v-model="viewLogDialog"
      ></view-log-dialog>
      <create-mom-comment
        v-if="commentDialog"
        v-model="commentDialog"
        :meetingObject="meetingObject"
        :commentData="comment"
        @saveComment="saveComment"
      ></create-mom-comment>
      <Loader :loading="Loaderloading" :message="LoaderText"></Loader>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="displayMessage = false"
      ></MessageSheet>
    </v-card>
  </a-dialog>
</template>

<script>
import MomCommentTimelineCard from "./MomCommentTimelineCard.vue";
import ViewLogDialog from "./ViewLogDialog.vue";
import CreateMomComment from "./CreateMomComment.vue";
import { mapGetters, mapActions } from "vuex";
import { formatDate } from "../../../utils/util";
import SignalRMixin from "../../../mixin/SignalRMixin";
import Loader from "@/components/Loader.vue";
import MessageSheet from "@/components/MessageSheet.vue";

export default {
  name: "MomDraftComment",
  mixins: [SignalRMixin],
  components: {
    MomCommentTimelineCard,
    ViewLogDialog,
    CreateMomComment,
    Loader,
    MessageSheet,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    meetingObject: {
      type: Object,
      default: true,
    },
  },
  data() {
    return {
      viewLogDialog: false,
      commentDialog: false,
      comment: null,
      displayMessage: false,
      message: "",
      messageType: "",
      Loaderloading: false,
      stringLength: 80,      
    };
  },
  async mounted() {
    const target = "mom_comment_" + this.selectedTenant;
    await this.signalRInit(target); // Commented for voting Enhancement issue
  },
  watch: {
    "$auth.user": {
      async handler(newValue, oldValue) {
        if (newValue) {
          try {
            this.Loaderloading = true;
            await this.getMomComments(this.meetingObject.id);
            this.Loaderloading = false;
          } catch (error) {
            this.Loaderloading = false;
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      getMeetingComments: "meeting/getMeetingComments",
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    commentDateFormat() {
      return this.selectedLang !== "ja"
        ? "yyyy/MM/dd HH:mm"
        : "yyyy/MM/dd HH:mm";
    },
    LoaderText() {
      return this.$t("LoaderText");
    },
    addMomCommentPermission() {
      if (this.meetingObject.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingObject.meetingTypeId,
          "AddMomComment"
        );
      }
      return false;
    },
    viewMomCommentPermission() {
      if (this.meetingObject.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingObject.meetingTypeId,
          "ViewMomComment"
        );
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      getMomComments: "meeting/getMomComments",
      getMomcommentslog: "meeting/getMomcommentslog",
    }),
     ellipsis(string) {
      return  this.isEllipsis(string) ? string.substring(0, this.stringLength) + "..." : string;
    },
    isEllipsis(string) {
      return  String(string).length > this.stringLength;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    commentDate(commentdate) {
      return formatDate(new Date(commentdate), this.commentDateFormat);
    },
    close() {
      this.$emit("input", false);
      this.comment = null;
    },
    async viewLog() {
      this.Loaderloading = true;
      try {
        await this.getMomcommentslog(this.meetingObject.id);
        this.Loaderloading = false;
        this.viewLogDialog = true;
      } catch (error) {
        this.viewLogDialog = false;
        this.Loaderloading = false;
      }
    },
    createComment() {
      this.comment = null;
      this.commentDialog = true;
    },
    editComment(comment) {
      this.comment = comment;
      this.commentDialog = true;
    },
    saveComment(response) {
      if (response.status) {
        this.showMessageSheet(this.$t("agenda.commentSuccessMsg"), "success");
      } else {
        this.showMessageSheet(this.$t("agenda.commentFaildMsg"), "error");
      }
      this.commentDialog = false;
    },
    async signalRInit(target) {
      if (!this.viewMomCommentPermission) {
        return;
      }
      try {
        this.signalConnection.on(target, async (res) => {
          this.Loaderloading = true;
          await this.getMomComments(this.meetingObject.id);
          this.getMomcommentslog(this.meetingObject.id);
          this.Loaderloading = false;
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        this.Loaderloading = false;
      }
    },
  },
};
</script>
